import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//primereact
import { Button } from "primereact/button";
//components
import Select from "../../../../../../../components/input/Select";
import Toggle from "../../../../../../../components/button/Toggle";
import NumberInput from "../../../../../../../components/input/NumberInput";
//services
import { getOwner } from "../../../../../../../services/GlobalRoles/getOwner";
import { postLandOwners } from "../../../../../../../services/Contracts/postLandOwners";
//utils
import { queryClient } from "../../../../../../../utils/queryClient";
import { useAppContext } from "../../../../../../../context/AppContext";

export const FiltersOwners = ({ id }) => {
  const form = useForm();
  const errors = form.formState.errors;
  const [newOwners, setNewOwners] = useState([{}]);
  const [totalPercentage, setTotalPercentage] = useState(0);
  const { permissions } = useAppContext();

  const { data: owners, isLoading: loadingOwners } = useQuery({
    queryKey: ["owners"],
    queryFn: () => getOwner(),
    enabled: !!permissions?.includes("59")
  });

  const onSubmit = async (data) => {
    data.sale_id = id;
    data.owners = [];
    let hasOwner = [];
    const formattedData = data.owner
      .map((owner, index) => {
        if (owner) {
          if (data.percentage[index] > 0) {
            hasOwner.push(data.holder[index]);
            return {
              client_id: owner,
              percentage: data.percentage[index],
              owner: data.holder[index],
            };
          }
        }
      })
      .filter((item) => item !== undefined);
    if (!hasOwner.includes(true)) {
      toast.warn("Selecione ao menos um titular!");
      return;
    }
    data.owners = formattedData;
    delete data.owner;
    delete data.percentage;
    delete data.holder;
    const notification = toast.loading("Por favor aguarde...");
    try {
      await postLandOwnersFn(data);
      toast.update(notification, {
        render: "Informação Salva com Sucesso",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      setNewOwners([{}]);
      setTotalPercentage(0);
      form.reset();
    } catch (err) {
      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
    }
  };

  const { mutateAsync: postLandOwnersFn } = useMutation({
    mutationFn: postLandOwners,
    onSuccess(_, variables) {
      queryClient.setQueryData([`landOwners${id}`], (data) => {
        return variables;
      });
    },
    onError(error) {
      // console.log(error);
    },
  });

  const testPercentage = () => {
    let total = 0;
    newOwners.map((c) => {
      if (c.percentage) {
        total += c.percentage;
      }
      return total;
    });
    return total;
  };

  const handleAddClients = () => {
    const testArray = [...newOwners, {}];
    if (testArray.length !== 1 && testArray.length % 2 !== 0) {
      toast.warning(
        "Se atente as casas decimais, a soma deve ser exatamente 100%"
      );
    }
    setNewOwners([...newOwners, {}]);
  };

  const handleRemoveClients = (e, index) => {
    e.preventDefault();
    form.setValue(`owner[${index}]`, "");
    form.setValue(`percentage[${index}]`, "");
    form.setValue(`holder[${index}]`, false);
    const updatedClients = [...newOwners];
    updatedClients.splice(index, 1);
    if (updatedClients.length !== 1 && updatedClients.length % 2 !== 0) {
      toast.warning(
        "Se atente as casas decimais, a soma deve ser exatamente 100%"
      );
    }
    setNewOwners(updatedClients);
  };

  const handleInputChange = (e, index) => {
    const updateOwners = [...newOwners];
    updateOwners[index] = {
      ...updateOwners[index],
      percentage: e.value,
    };
    setNewOwners(updateOwners);
  };

  const onChangeHolder = (indexToggle) => {
    const valueToggle = form.getValues(`holder[${indexToggle}]`);
    if (valueToggle) {
      newOwners.forEach((cli, index) => {
        if (index !== indexToggle) {
          form.setValue(`holder[${index}]`, false);
        }
      });
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    const total = testPercentage();
    setTotalPercentage(total);
  }, [newOwners]);

  // useEffect(() => {
  //   if (newOwners.length !== 1 && newOwners.length % 2 !== 0) {
  //     toast.warning(
  //       "Se atente as casas decimais, a soma deve ser exatamente 100%"
  //     );
  //   }
  // }, [newOwners]);

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
      <div className="row">
        {newOwners.map((cli, index) => (
          <div
            className={`row col-xl-9 ${window.innerWidth <= 992 ? "" : "d-flex"}`}
            key={index}
          >
            <div className="col-xl-5 col-md-6 mb-1">
              <Select

                name={`owner[${index}]`}
                label={loadingOwners ? "Carregando..." : "Proprietário"}
                isRequired={true}
                disabled={loadingOwners && (permissions && !permissions.includes("77"))}//Cadastrar / Editar Proprietarios  
                errors={errors}
                control={form.control}
                options={
                  owners &&
                  owners.map((item) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })
                }
              />
            </div>
            <div
              className={`col-xl-3 col-md-6 ${window.innerWidth <= 992 ? "" : "ms-4 mb-1"
                }`}
            >
              <NumberInput
                disabled={(permissions && !permissions.includes("77"))}//Cadastrar / Editar Proprietarios  
                name={`percentage[${index}]`}
                suffix="%"
                placeholder="0%"
                max={100}
                errors={errors}
                minFractionDigits={2}
                maxFractionDigits={2}
                tooltip={
                  index === 0 &&
                  totalPercentage !== 100 &&
                  "O total precisa ser 100%"
                }
                onChange={(e) => handleInputChange(e, index)}
                tooltipOptions={{ position: "top" }}
                control={form.control}
                label="% Participação"
              />
            </div>
            <div className="col-xl-2 col-md-6 my-2 form-group pt-3">
              <Toggle
                control={form.control}
                name={`holder[${index}]`}
                onLabel="Titular"
                offLabel="Titular"
                onChange={() => onChangeHolder(index)}
                getFormErrorMessage={getFormErrorMessage}
              />
            </div>
            {totalPercentage < 100 && (
              <div className="col-xl-2 col-md-6 pt-4">
                {index > 0 && (
                  <Button
                    disabled={(permissions && !permissions.includes("77"))}//Cadastrar / Editar Proprietarios  
                    rounded
                    outlined
                    severity="danger"
                    icon="fa fa-minus"
                    className="mx-2 mt-1"
                    onClick={(e) => handleRemoveClients(e, index)}
                    style={{
                      width: "2rem",
                      height: "2rem",
                      padding: "2px",
                    }}
                  />
                )}
                {index === newOwners.length - 1 && (permissions && permissions.includes("77")) && (//Cadastrar / Editar Proprietarios   (
                  <Button
                    rounded
                    outlined
                    size="small"
                    severity="success"
                    icon="fa fa-plus"
                    onClick={handleAddClients}
                    className="mx-2 mt-1 pt-1"
                    style={{
                      width: "2rem",
                      height: "2rem",
                      padding: "2px",
                    }}
                  />
                )}
              </div>
            )}
          </div>
        ))}
        {permissions && permissions.includes("77") && ( //Cadastrar / Editar Proprietarios  
          <div className="col-md-12 text-end mb-2">
            <Button
              rounded
              type="submit"
              disabled={totalPercentage !== 100}
              iconPos="right"
              label="Cadastrar"
              icon="fa-solid fa-circle-chevron-right"
              className="p-inputtext-sm mt-4 me-2 m-auto w-80"
            />
          </div>
        )}
      </div>
    </form>
  );
};
